import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { adminService } from '../../services'

// Async thunks
export const loginAdmin = createAsyncThunk(
  'auth/loginAdmin',
  async ({ email, password }, { rejectWithValue }) => {
    try {
      const response = await adminService.login(email, password)
      return response
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
)

export const registerAdmin = createAsyncThunk(
  'auth/registerAdmin',
  async (adminData, { rejectWithValue }) => {
    try {
      const response = await adminService.register(adminData)
      return response
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
)

export const logoutAdmin = createAsyncThunk(
  'auth/logoutAdmin',
  async (_, { rejectWithValue }) => {
    try {
      await adminService.logout()
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
)

export const getCurrentAdmin = createAsyncThunk(
  'auth/getCurrentAdmin',
  async (_, { rejectWithValue }) => {
    try {
      const response = await adminService.getCurrentAdmin()
      return response
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
)

const initialState = {
  admin: null,
  isAuthenticated: false,
  loading: false,
  error: null,
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null
    },
    clearAuth: (state) => {
      state.admin = null
      state.isAuthenticated = false
      state.loading = false
      state.error = null
      // Clear admin data from localStorage
      localStorage.removeItem('admin')
    },
    setCredentials: (state, action) => {
      const { admin } = action.payload
      state.admin = admin
      state.isAuthenticated = true
    },
    updateAdmin: (state, action) => {
      if (state.admin) {
        state.admin = {
          ...state.admin,
          ...action.payload
        }
      }
    },
  },
  extraReducers: (builder) => {
    builder
      // Login
      .addCase(loginAdmin.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(loginAdmin.fulfilled, (state, action) => {
        state.loading = false
        state.admin = action.payload.data.admin
        state.isAuthenticated = true
        state.error = null
        // Store admin data in localStorage for persistence
        localStorage.setItem('admin', JSON.stringify(action.payload.data.admin))
      })
      .addCase(loginAdmin.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
        state.isAuthenticated = false
      })
      
      // Register
      .addCase(registerAdmin.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(registerAdmin.fulfilled, (state, action) => {
        state.loading = false
        state.admin = action.payload.data.admin
        state.isAuthenticated = true
        state.error = null
      })
      .addCase(registerAdmin.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
        state.isAuthenticated = false
      })
      
      // Logout
      .addCase(logoutAdmin.pending, (state) => {
        state.loading = true
      })
      .addCase(logoutAdmin.fulfilled, (state) => {
        state.loading = false
        state.admin = null
        state.isAuthenticated = false
        state.error = null
        // Clear admin data from localStorage
        localStorage.removeItem('admin')
      })
      .addCase(logoutAdmin.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      
      // Get current admin
      .addCase(getCurrentAdmin.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getCurrentAdmin.fulfilled, (state, action) => {
        state.loading = false
        state.admin = action.payload.data.admin
        state.isAuthenticated = true
        state.error = null
      })
      .addCase(getCurrentAdmin.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
        state.isAuthenticated = false
      })
  }
})

export const { clearError, clearAuth, setCredentials, updateAdmin } = authSlice.actions
export default authSlice.reducer
